// extracted by mini-css-extract-plugin
var _1 = "chdtuBc4vxkM3pHkz7rX";
var _2 = "EJBbGjaTW1mrdJa6Dw7G";
export { _1 as "drawer", _2 as "drawerContent" }
